import moment from 'moment/moment'
import React, { FC, useEffect } from 'react'
import {
  Control,
  UseFieldArrayRemove,
  UseFormRegister,
  UseFormReset,
  UseFormWatch,
} from 'react-hook-form'

import { ScheduleItemByClass } from './ScheduleItemByClass'
import { ScheduleItemByRider } from './ScheduleItemByRider'

import { selectedEvent } from '../../../../../store/events/eventsSlice'
import { useAppSelector } from '../../../../../store/hooks'

import { filteredSchedule, IFilters } from '../SchedulingScreenEventSchedulingFormComponent'

import { EventSchedulingModel } from '../../../../../models/event-scheduling/event-scheduling.model'

import { UseFormSetValue, UseFormTrigger } from 'react-hook-form/dist/types/form'
import { RegistrationFeesType } from '../../../../../models/event-fees/event-fees.interface'
import { IRegistrationByDayInterface } from '../../../../../models/registrations-by-day/registrationByDay.interface'

interface CustomSchedulesProps {
  handleModal: (showHide: boolean, typeOfModal: string, dataToPassOn?: any) => void
  locationOptions: { label: string; value: string }[]
  control: Control<any>
  watch: UseFormWatch<any>
  setValue: UseFormSetValue<any>
  errors: any
  register: UseFormRegister<any>
  trigger: UseFormTrigger<any>
  reset: UseFormReset<any>
  remove: UseFieldArrayRemove
  filters: IFilters
  searchValue: string
  scheduleBy: 'rider' | 'class'
  selectedIds: string[]
  onSelected: (id: string) => void
  isBatchSchedule: boolean
  registrationByDay: IRegistrationByDayInterface[]
}

const eventSchedulingFormDefaultValues = new EventSchedulingModel().toObject()

export const CustomSchedules: FC<CustomSchedulesProps> = ({
  handleModal,
  register,
  control,
  watch,
  trigger,
  setValue,
  errors,
  reset,
  locationOptions,
  remove,
  filters,
  searchValue,
  scheduleBy,
  selectedIds,
  onSelected,
  isBatchSchedule,
  registrationByDay,
}) => {
  const selectedEventR = useAppSelector(selectedEvent)

  const areAllFieldsValid = (index: number) => {
    const locationIsValid = !!watch(`custom.${index}.location`)
    const nameIsValid = !!watch(`custom.${index}.name`)?.trim()
    const startDateIsValid = moment(watch(`custom.${index}.startDate`)).isValid()

    if (scheduleBy === 'class') {
      const tagIsValid = !!watch(`custom.${index}.tag`)
      return nameIsValid && startDateIsValid && tagIsValid && locationIsValid
    } else {
      // for rider scheduling - check increment
      const incrementIsValid = !!watch(`custom.${index}.increment`)
      return nameIsValid && startDateIsValid && incrementIsValid && locationIsValid
    }
  }

  useEffect(() => {
    if (selectedEventR.EventSchedule) reset(selectedEventR.EventSchedule)
    else reset(eventSchedulingFormDefaultValues)
  }, [reset, selectedEventR.EventSchedule, trigger])

  // render appropriate component based on scheduleBy mode
  const renderScheduleItem = (index: number) => {
    const commonProps = {
      index,
      handleModal,
      register,
      control,
      watch,
      trigger,
      setValue,
      locationOptions,
      remove,
      areAllFieldsValid,
      selector: `custom.${index}` as const,
      errorSelector: errors?.custom?.[index],
      selectedIds,
      onSelected,
      isBatchSchedule,
      registrationByDay,
    }

    if (scheduleBy === 'class') {
      return <ScheduleItemByClass key={index} {...commonProps} />
    } else {
      return <ScheduleItemByRider key={index} {...commonProps} />
    }
  }

  return (
    <>
      {watch('custom').map((field: RegistrationFeesType, index: number) =>
        filteredSchedule({ searchValue, filters, field, registrationByDay })
          ? renderScheduleItem(index)
          : null
      )}
    </>
  )
}
